import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const ZipCode = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.zipCode"
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="85. ZIP Code"
          field={field}
          input={(props) => <TextInput {...props} maxLength={9} data-qa="85. ZIP Code" />}
        />
      )}
    />
  )
}
